import styled from "styled-components"

import { color } from "../../../atoms/colors"
import globebg from "../../../images/Blue-Globe.png"

export const PlatformGlobeContainer = styled.div`
  position: relative;
  background: linear-gradient(
    103.16deg,
    ${color.common.gradientBlue} -0.76%,
    ${color.oxfordBlue[900]} 52.98%
  ) !important;
  &.bg-sprite {
    .eyebrow {
      border: 2px solid ${color.oxfordBlue[600]} !important;
      color: ${color.oxfordBlue[600]} !important;
    }
  }
  &.bg-plum {
    .heading {
      color: ${color.common.white} !important;
    }
  }
  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 70px;
    display: block;
    background-color: ${color.common.white};
    @media (max-width: 991.98px) {
      display: none;
    }
  }
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 70px;
    display: block;
    background-color: ${color.common.white};
    z-index: 1;
  }
  .container {
    max-width: 1170px !important;
  }
  .content {
    @media (max-width: 991.98px) {
      flex-direction: column-reverse;
      margin: 0 auto;
      max-width: 770px;
    }
    @media (max-width: 767.98px) {
      max-width: 506px;
    }
  }
  .globe-content {
    @media (max-width: 991.98px) {
      margin: auto;
    }
    @media (max-width: 767.98px) {
      margin: -70px auto;
    }
  }
  .heading-container {
    @media (max-width: 991.98px) {
      max-width: 770px;
      margin: 56px auto 0 auto;
    }
    @media (max-width: 767.98px) {
      max-width: 506px;
    }
    .eyebrow {
      font-weight: 900;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: ${color.secondary[400]};
      margin: 8px 0;
      @media (max-width: 575.98px) {
        font-size: 12px;
        line-height: 18px;
      }
    }
    .heading {
      font-weight: 900;
      font-size: 24px;
      line-height: 32px;
      color: ${color.common.white};
    }
    .description {
      h3 {
        font-weight: 900;
        font-size: 18px;
        line-height: 28px;
        margin: 8px 0 4px 0;
      }
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .globe-bg {
    position: relative;
    z-index: 2;
    min-height: 760px;
    background-image: url(${globebg});
    background-repeat: no-repeat;
    background-position: right center;
    background-size: contain;
    display: inline-block;
    @media (max-width: 991.98px) {
      margin: -70px 0;
    }
    @media (max-width: 1280px) {
      min-height: 760px;
    }
    * {
      font-size: 20px;
      line-height: 28px;
    }
    p {
      margin-bottom: 0.5rem;
    }
    .clickatell-green-bg {
      width: 50px;
      height: 3px;
      background-color: ${color.secondary[600]};
    }
  }
  .hyperlink-white {
    color: ${color.common.white};
    text-decoration: underline;
    padding-left: 3px;
    &:hover {
      text-decoration: none;
    }
  }
  .tooltip-label {
    position: relative;
    &:after {
      content: "";
      border-bottom: 1px dashed ${color.common.white};
      display: inline-block;
      position: absolute;
      left: 0;
      bottom: -1px;
      width: 100%;
    }
  }
`
